export enum AsyncModelStatus {
    Resolved = "resolved",
    Pending = "pending",
    Error = "error"
}
